// MUI X Charts measures tick labels in a hidden `<svg aria-hidden="true">` it appends to `<body>`,
// outside every `data-notranslate` wrapper. Start before Localize: observers run in creation order.
export const blockChartMeasurementFromLocalize = (): MutationObserver => {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof SVGSVGElement && node.getAttribute("aria-hidden") === "true") {
          node.dataset.notranslate = "true";
        }
      }
    }
  });

  observer.observe(document.body, { childList: true });

  return observer;
};
